import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageServerActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="data-catalog-lineage-server-active_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".data-catalog-lineage-server-active_svg__st0{fill:#333}"}</style>
    <path
      className="data-catalog-lineage-server-active_svg__st0"
      d="M16 8h2V7h-2zM16 11h2v1h-2zM16 15h2v1h-2z"
    />
    <path
      className="data-catalog-lineage-server-active_svg__st0"
      d="M20 6c0-.5-.5-1-1-1H5c-.5 0-1 .5-1 1v3c0 .2.1.4.2.5-.1.2-.2.3-.2.5v3c0 .2.1.4.2.5-.1.2-.2.3-.2.5v3c0 .5.5 1 1 1h14c.5 0 1-.5 1-1v-3c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5v-3c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V6zM5 6h14v3H5V6zm14 7H5v-3h14v3zm0 4H5v-3h14v3z"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageServerActive);
export default Memo;
